import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'

import { IQueryResult } from 'core-components/types'
import { Crud } from 'core/types'
import { EExceptionRequestCrudKey, exceptionRequestApi } from 'onboarding/api/exceptionRequestApi'
import {
  IExcCategory,
  IException,
} from 'onboarding/components/widgets/public/admin/exceptionsReasons/models'

class ExceptionRequestService {
  public getExceptionsCrud(
    type?: RequestTypes,
    crudKey?: EExceptionRequestCrudKey
  ): Crud<IException> {
    return exceptionRequestApi.getExceptionsCrud(type, crudKey)
  }

  public getExceptionCategoriesCrud(
    type?: RequestTypes,
    crudKey?: EExceptionRequestCrudKey
  ): Crud<IExcCategory> {
    return exceptionRequestApi.getExceptionCategoriesCrud(type, crudKey)
  }

  public getActiveExceptions(
    type: RequestTypes,
    crudKey?: EExceptionRequestCrudKey
  ): Promise<IQueryResult<IException, any>> {
    return exceptionRequestApi.getActiveExceptions(type, crudKey)
  }

  public getTypeExceptionsCrud(type: RequestTypes, crudKey?: EExceptionRequestCrudKey) {
    return exceptionRequestApi.getTypeExceptionsCrud(type, crudKey)
  }

  public getEmptyExceptionsCrud() {
    return exceptionRequestApi.getEmptyExceptionsCrud()
  }

  public getActiveExceptionsFilteredBy(
    type: RequestTypes,
    filter: Partial<IException>
  ): Crud<IException, any> {
    return exceptionRequestApi.getActiveExceptionsFilteredBy(type, filter)
  }

  public getExceptionByCode(
    type: RequestTypes,
    code: string,
    needCache: boolean = false
  ): Promise<IException | null> {
    return exceptionRequestApi.getExceptionByCode(type, code, needCache)
  }

  public getCategoriesCrudFilteredByExceptionCode(params: {
    type: RequestTypes
    exceptionCode: string
    crudKey: EExceptionRequestCrudKey
    isActive?: boolean
  }) {
    return exceptionRequestApi.getCategoriesCrudFilteredByExceptionCode(params)
  }
}

export const exceptionRequestService = new ExceptionRequestService()
